var _path, _circle, _g, _circle2, _g2, _circle3, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGraph = function SvgGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 23 204 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#graph_svg__a)",
    strokeWidth: 2.844,
    d: "m1 99.285 16.567-11.787c3.517-2.503 8.434-1.32 10.427 2.51l15.152 29.109c2.164 4.158 7.691 5.119 11.133 1.936l11.202-10.362a7.109 7.109 0 0 1 10.015.358l9.601 10.247c3.823 4.08 10.64 2.354 12.063-3.052L111.8 62.582c1.915-7.28 12.351-6.98 13.842.4l12.521 61.924c1.02 5.045 6.896 7.367 11.089 4.384l13.541-9.635a7.1 7.1 0 0 0 1.357-1.263l15.277-18.479c3.372-4.078 9.86-3.174 11.988 1.671L210 143.898",
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118.296,
    cy: 56.459,
    r: 20.616,
    fill: "#AD273C",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#graph_svg__b)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.296,
    cy: 56.459,
    r: 25.328,
    fill: "#AD273C"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.296,
    cy: 56.459,
    r: 15.511,
    fill: "#AD273C",
    opacity: 0.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#graph_svg__c)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.296,
    cy: 56.459,
    r: 29.647,
    fill: "#AD273C"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.296,
    cy: 56.459,
    r: 9.621,
    fill: "#AD273C",
    opacity: 0.75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.295,
    cy: 56.459,
    r: 4.123,
    fill: "#AD273C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "graph_svg__b",
    width: 54.678,
    height: 54.678,
    x: 90.957,
    y: 29.12,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1363_84100",
    stdDeviation: 1.006
  })), /*#__PURE__*/React.createElement("filter", {
    id: "graph_svg__c",
    width: 159.859,
    height: 159.859,
    x: 38.367,
    y: -23.47,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1363_84100",
    stdDeviation: 25.141
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graph_svg__a",
    x1: 215.929,
    x2: 1.647,
    y1: 136.078,
    y2: 93.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018EF5",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;